// FreightDescriptionModal.tsx
import { Dialog, DialogContent, DialogTitle, Divider } from "@mui/material";
import React from "react";

import MDBox from "@/components/atoms/MDBox";
import MDTypography from "@/components/atoms/MDTypography";
import { CustomerFormMessages } from "@/messages/customer/customer-form.messages";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  messages: CustomerFormMessages;
};

const FreightDescriptionModal = ({ isOpen, onClose, messages }: Props) => {
  const renderLine = (text: string) => {
    const [boldPart, ...rest] = text.split(":");
    return (
      <>
        <MDTypography variant="body2" color="text">
          <MDTypography component="span" variant="body2" fontWeight="bold" color="dark">
            {boldPart}:
          </MDTypography>{" "}
          {rest.join(":").trim()}
        </MDTypography>
        <br />
      </>
    );
  };

  const renderSectionTitle = (text: string) => (
    <MDTypography variant="subtitle2" fontWeight="bold" color="dark" mt={2} mb={0.5}>
      {text}
    </MDTypography>
  );

  const renderParagraph = (text: string) => (
    <MDTypography variant="body2" color="text" mb={1}>
      {text}
    </MDTypography>
  );

  const renderBullet = (text: string) => (
    <MDTypography variant="body2" color="text" component="li" sx={{ mb: 0.5 }}>
      {text}
    </MDTypography>
  );

  return (
    <Dialog open={isOpen} onClose={onClose} sx={{ p: 2 }} maxWidth="md">
      <DialogTitle>{messages.freightDescriptionTitle}</DialogTitle>
      <DialogContent>
        {renderLine(messages.freightModalTextNonUse)}
        {renderLine(messages.freightModalTextOwn)}
        {renderLine(messages.freightModalTextAutomated)}

        <Divider sx={{ my: 2 }} />

        <MDTypography variant="h6" fontWeight="bold" color="dark">
          {messages.freightOverheadDocTitle}
        </MDTypography>

        {renderSectionTitle(messages.freightOverheadDocNeedTitle)}
        {renderParagraph(messages.freightOverheadDocNeedText)}

        {renderSectionTitle(messages.freightOverheadDocBehaviorTitle)}
        <MDBox component="ul" pl={2.5} m={0}>
          {renderBullet(messages.freightOverheadDocBehaviorMonetary)}
          {renderBullet(messages.freightOverheadDocBehaviorPercentage)}
        </MDBox>

        {renderSectionTitle(messages.freightOverheadDocExceptionsTitle)}
        <MDBox component="ul" pl={2.5} m={0}>
          {renderBullet(messages.freightOverheadDocExceptionZeroFreight)}
          {renderBullet(messages.freightOverheadDocExceptionNoValue)}
          {renderBullet(messages.freightOverheadDocExceptionFreeShipping)}
        </MDBox>

        {renderSectionTitle(messages.freightOverheadDocExampleTitle)}
        <MDBox component="ul" pl={2.5} m={0}>
          {renderBullet(messages.freightOverheadDocExampleMonetary)}
          {renderBullet(messages.freightOverheadDocExamplePercentage)}
          {renderBullet(messages.freightOverheadDocExampleZero)}
        </MDBox>

        <MDTypography variant="caption" color="text" display="block" mt={2}>
          {messages.freightOverheadDocNote}
        </MDTypography>
      </DialogContent>
    </Dialog>
  );
};

export default FreightDescriptionModal;
